export interface KeywordFilterType {
  query: string
}

export const initialKeywordFilter: KeywordFilterType = {
  query: ""
};